import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const JsonBlock = ({ title, value }) => {
  const [copied, setCopied] = useState(false);

  const printable = useMemo(() => {
    const isString = typeof value === 'string';
    return isString ? value : JSON.stringify(value ?? null, null, 2);
  }, [value]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(printable);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch (e) {
      try {
        const ta = document.createElement('textarea');
        ta.value = printable;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1200);
      } catch (_) {
      }
    }
  };

  return (
    <div className="audit-json-block">
      <div className="audit-json-block__header">
        <div className="audit-json-block__title">{title}</div>

        <button
          type="button"
          className="audit-json-block__copyBtn"
          onClick={handleCopy}
          aria-label="Copy JSON"
          title="Copy"
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>

      <pre className="audit-json-block__pre">{printable}</pre>
    </div>
  );
};

JsonBlock.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.any,
};

JsonBlock.defaultProps = {
  value: null,
};

export default JsonBlock;
